import React from 'react'
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Outlet } from "react-router-dom";
import UserSessionDialog from '../../components/UserSessionDialog';
import InactivitySessionDialog from '../../components/InactivitySessionDialog';


const MainWrapper = styled(Box)(() => `
         
          height: 100%;
  `
);

const MainContent = styled(Box)(({ theme }) => ({
    color: theme.palette.secondary.main
}));


const FullLayout = () => {
    return (
        <MainWrapper>
            <MainContent>
                <Outlet />
                <UserSessionDialog/>
                <InactivitySessionDialog/>
            </MainContent>
        </MainWrapper>
    )
}

export default FullLayout